import { HttpResponse } from '@angular/common/http';
import { createLesson, Lesson, LessonDto } from '@app/store/shared/models';

export class PaginatedDto {
    readonly payload: Lesson[];
    readonly total: number;

    constructor(response: HttpResponse<LessonDto[]>) {
        this.payload = (response.body ?? []).map((dto) => createLesson(dto));
        this.total = parseInt(response.headers.get('X-Total-Count') ?? '0', 10);
    }
}
